import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { Emily } from '../../../services/emily';

@Component({
  selector: 'ems-floating-emily-button',
  standalone: true,
  imports: [CommonModule, TranslatePipe, Button],
  templateUrl: './floating-emily-button.html',
  styleUrls: ['./floating-emily-button.scss'],
})
export class FloatingEmilyButtonComponent {
  emily: Emily = inject(Emily);
}
